import { GET } from "./utils";

export interface CreditPromoStatus {
    isActive: boolean;
    promotion: { id: string; name: string; startDate: string; endDate: string } | null;
    creditLimit: number;
    creditsUsed: number;
    creditsRemaining: number;
    percentUsed: number;
    pricePerCredit: number;
    totalValueDollars: number;
}

/**
 * Get credit promotion status for a workspace
 * Works for both authenticated and guest users
 * @param workspaceId - Optional workspace ID. If not provided, returns general promo info
 */
export const getCreditPromoStatus = async (workspaceId?: string): Promise<CreditPromoStatus> => {
    const url = workspaceId
        ? `/api/credit-promo/status?workspaceId=${encodeURIComponent(workspaceId)}`
        : "/api/credit-promo/status";

    return GET(url);
};
